module.exports = __webpack_public_path__ + "static/media/Logo_InPixio-2.0faded75.png";